var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border-bottom":"1px solid rgb(210, 213, 217)"}},[_c('layout-content-menu',{attrs:{"items":_vm.items,"white":"","selected":_vm.selected,"stacked":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }